import { notify } from '@offerzen/react-utils'

export const candidateStateMap = {
  onboarding: {
    id: 'onboarding',
    label: 'Onboarding',
  },
  pre_review: {
    id: 'pre_review',
    label: 'Pre-review',
  },
  technical_screening: {
    id: 'technical_screening',
    label: 'Technical Screening',
  },
  in_review: {
    id: 'in_review',
    label: 'In Review',
  },
  accepted: {
    id: 'accepted',
    label: 'Accepted',
  },
  ready_to_go_live: {
    id: 'ready_to_go_live',
    label: 'Ready to go live',
  },
  ready_for_event: {
    id: 'ready_for_event',
    label: 'Ready for event',
  },
  live: {
    id: 'live',
    label: 'Live',
  },
  post_live: {
    id: 'post_live',
    label: 'Post-Live',
  },
  post_event: {
    id: 'post_event',
    label: 'Post event',
  },
  placed: {
    id: 'placed',
    label: 'Placed',
  },
  not_placed: {
    id: 'not_placed',
    label: 'Not placed',
  },
  rejected_no_current_match: {
    id: 'rejected_no_current_match',
    label: 'Rejected (No current match)',
  },
  rejected_never_matched: {
    id: 'rejected_never_matched',
    label: 'Rejected (Never matched)',
  },
}

const validateComprehensiveLocation = ({ locationOsmStrings, locationId }) => {
  if (!locationOsmStrings[locationId]) {
    const error = {
      name: 'No location matches city ID',
      locationId,
    }
    return error
  }
  if (!locationOsmStrings[locationId].comprehensiveLocation) {
    const error = {
      name: 'No comprehensive_location found',
      locationId,
      locationOsmString: locationOsmStrings[locationId],
    }
    return error
  }
}

export const formatPreferredLocations = ({ cities, locationOsmStrings }) => {
  let errors = []
  const selectedPreferredLocations = cities.map(locationId => {
    const error = validateComprehensiveLocation({ locationOsmStrings, locationId })
    if (error) {
      errors = [...errors, error]
      return null
    }
    const formattedLocation = locationOsmStrings[locationId].comprehensiveLocation
    formattedLocation.location_category = 'preferred'

    return formattedLocation
  })
  try {
    if (errors.length) throw new Error('Invalid preferred location', errors)
  } catch (error) {
    notify(error)
  }

  return { selectedPreferredLocations, errors }
}

/**
 * Check if the candidate is in a specified state.
 *
 * @param {string} candidateState - The candidate's current state. Not case sensitive.
 * @param {string} state - The specified state for which to compare the candidate's state to. Not case sensitive.
 * @returns {boolean} - True/false whether or not the candidate is in the specified state respectively.
 */
export const isCandidateInState = (candidateState, state) => {
  return candidateState?.toLowerCase() === state.toLowerCase()
}
